'use client';

const scrollableContent = "Keyboard-controlled scrollbar";
export {
  scrollableContent
};
